import React, { useEffect, useState } from "react";
import useSWR, { mutate } from "swr";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SecureLS from "secure-ls";
import LoaderAnimation from "./LoaderAnimationLarge";
const ls = new SecureLS({ encodingType: "aes" });

// const usercsrf_token = ls.get("usercsrf_token");

// const fetcher = (url) =>
//   fetch(url, {
//     credentials: "include",
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//       "X-CSRF-Token": usercsrf_token,
//     },
//   })
//     .then((res) => res.json())
//     .then((data) => (Array.isArray(data) ? data : [data]));

const UpdateCTScanRequestPayout = ({ requestData, setPatientNameState }) => {
  const [loading, setLoading] = useState(false);
  const [csrfToken, setCsrfToken] = useState("");
  const [payoutStatus, setPayoutStatus] = useState(
    requestData?.field_payout_status_key || "",
  );

  console.log("requestData?.payout_status_key", requestData?.payout_status_key);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}/session/token`,
          { credentials: "include" },
        );
        const token = await res.text();
        setCsrfToken(token);
      } catch (err) {
        console.error("Error fetching CSRF token:", err);
      }
    })();
  }, []);

  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const ctrequestUpdatePayload = {
        type: [{ target_id: "ct_scan_request" }],
        field_payout_status: [{ value: payoutStatus }],
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/node/${requestData.request_nid}?_format=json`,
        {
          method: "PATCH",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken,
          },
          body: JSON.stringify(ctrequestUpdatePayload),
        },
      );

      // Clone the response to read it multiple times if needed
      const responseClone = response.clone();

      // First, try to read as JSON for success case
      if (response.ok) {
        try {
          const successData = await response.json();
          console.log("PATCH successful:", successData);
          alert("CT Scan request edited successfully");

          // Reset form fields
          setPayoutStatus("");

          // Refresh the data
          await Promise.all([
            mutate(`${process.env.REACT_APP_CT_SCAN_REQUEST_URL}`),
            mutate(`${process.env.REACT_APP_CT_SCAN_REPORT_URL}`),
          ]);
        } catch (jsonError) {
          console.error("Error parsing JSON response:", jsonError);
          // alert("CT Scan request updated successfully!");
        }
      } else {
        // Handle error case - read as text to handle HTML errors
        try {
          const errorText = await responseClone.text();
          console.log("Error response text:", errorText);

          let errorMessage = "CT Scan request failed to edit";

          // Check for specific error messages in the response
          if (errorText.includes("This request has been reported")) {
            errorMessage =
              "This request has been reported. Editing is not allowed.";
          } else if (errorText.includes("Access denied")) {
            errorMessage = "You are not allowed to edit this request.";
          } else if (response.status === 500) {
            errorMessage =
              "This request has already been reported and cannot be edited.";
          } else if (response.status === 403) {
            errorMessage = "Permission denied. You cannot edit this request.";
          }

          alert(errorMessage);
        } catch (textError) {
          console.error("Error reading error response:", textError);
          alert("An error occurred while updating the request.");
        }
      }

      setLoading(false);
    } catch (error) {
      console.error("Network error:", error);
      alert("Network error. Please check your connection and try again.");
      setLoading(false);
    }
  };

  // if (investigationsError) {
  //   return (
  //     <LoaderAnimation loadingTxt="Failed to load investigations. Please check your connection." />
  //   );
  // }

  if (!requestData) {
    return <LoaderAnimation loadingTxt="Loading request data..." />;
  }

  return (
    <div className="edit-ctscan-request-register">
      <form onSubmit={handleSubmitEdit} className="edit-patient-form">
        <div className="form-group">
          <label>Payout Status</label>
          <select
            value={payoutStatus}
            onChange={(e) => setPayoutStatus(e.target.value)}
            required
          >
            <option value="">Select Payout Status</option>
            <option value="processing">Processing</option>
            <option value="paid">Paid</option>
            <option value="disputed">Disputed</option>
          </select>
        </div>
        {/* <div className="form-group">
          <label htmlFor="field_investigation">Investigation</label>
          <select
            value={ctscanIvestigation}
            onChange={(e) => {
              setctscanIvestigation(e?.target?.value);
            }}
            required
          >
            <option value="_none">
              {investigationsLoading
                ? "Loading Investigations..."
                : "Select Investigation"}
            </option>
            {investigationsData?.map((item) => (
              <option key={item.nid} value={item.nid}>
                {item.title}
              </option>
            ))}
          </select>
        </div> */}
        {/* <div className="form-group">
          <label htmlFor="field_cliniccal-diag">Clinical Diagnostic</label>
          <textarea
            type="textarea"
            placeholder="Enter Clinical Diagnostics"
            value={ctscanClinicalDiag}
            onChange={(e) => setctscanClinicalDiag(e.target.value)}
            required
          />
        </div> */}
        {/* <div className="form-group">
          <label htmlFor="field_comments">Comments</label>
          <textarea
            type="textarea"
            placeholder="Enter Comments"
            value={ctscanComments}
            onChange={(e) => setctscanComments(e.target.value)}
            required
          />
        </div> */}
        <div className="submitGroup">
          <button type="submit" disabled={loading}>
            {loading ? (
              <FontAwesomeIcon
                icon={faSpinner}
                spin={true}
                strokeWidth={20}
                fontSize={22}
              />
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateCTScanRequestPayout;
